<template>
    <div>
        <div class="baojiatitle">
            <h3 color="primary">{{ zidian.other }}</h3>

            <div style="margin-left: auto">
                <Button size="small" @click="isUpdate = !isUpdate">{{ isUpdate ? '完成编辑' : '进入编辑'
                    }}</Button>
                <Button size="small" @click="addOther">新增费用</Button>
                <Button size="small" @click="getList">加载预设</Button>
            </div>
        </div>
        <Row>
            <Col style="border: solid 1px #333" span="4" v-for="(item, index) in itemData.list" :key="index">
            <div class="othercol" :class="{ new: item.new }">
                <Checkbox class="chox" v-model="item.select"></Checkbox>
                <Input size="small" :border="false" v-model="item.name"></Input>
                <div style="padding: 10px;">
                    <hanshu v-model="item.function"></hanshu>
                </div>

                <div v-if="isUpdate">
                    <Button @click="prev(index)">前移</Button>
                    <Button @click="next(index)">后移</Button>
                    <Button class="otherclose" type="text" @click="itemData.list.splice(index, 1)">删除</Button>
                </div>

            </div>
            </Col>
        </Row>
    </div>
</template>

<script>
import modelData from "../baojia/modelData";
import hanshu from "../gongshi/hanshu.vue"
export default {
    props: ["data",],
    components: { hanshu },
    data() {
        return {
            zidian: modelData.zidian,
            itemData: {},
            units: ['ff', 'dd'],
            danjias: [
                {
                    name: "买单",
                    select: true,
                    bgCost: 1
                },
                {
                    name: "手册",
                    select: true,
                    bgCost: 1
                },
                {
                    name: "无缝对接",
                    select: true,
                    bgCost: 1
                },
                {
                    name: "香港报关",
                    select: true,
                    bgCost: 2
                },
            ],
            gongshi: {
                1: "danjia(0,'份','人民币')",
                3: "price(0,'人民币')"//一口价或者固定价格
            },
            isUpdate: false
        };
    },
    methods: {
        tt() {
            this.itemData = this.data;
        },
        getVal() {
            return this.itemData;
        },//获取其他收费项目
        getList() {
            this.axios({
                method: "post",
                url:
                    this.axios.ipPort + "/cloud-tms-server-omc/ordersChargesTemplet/list",
                data: {},
            }).then((res) => {
                var data = res.data.data.dataList;

                data = data.filter(function (item) {
                    return item.lable == '报价杂费' && item.bgCost == 3
                })



                var goal = this.itemData.list;
                //goal.length = 0;
                for (let i = 0; i < data.length; i++) {
                    var obj = {
                        name: data[i].name,
                        price: 0,
                        select: true,
                        function: this.gongshi[data[i].bgCost],
                        new: true
                    };


                    var result = goal.some((item) => {
                        if (item.name == obj.name) {
                            return true;
                        }
                    });
                    if (!result) {
                        goal.push(obj);
                    }
                }
            });
        },
        addOther() {
            var obj = {
                name: '费用名称',
                price: 0,
                select: true,
                function: this.gongshi[3],
                new: true
            }
            this.itemData.list.push(obj)
        },
        reCars(v) {
            var obj = {
                name: v.bind,
                id: v.id,
                useType: v.useType,
            };

            var result = this.dataList.some((item) => {
                if (item.id == obj.id) {
                    return true;
                }
            });
            if (result) {
                this.$Message.error("（" + obj.name + "）已存在");
            } else {
                this.dataList.unshift(obj);
            }
        },
        prev(index) {
            if (index == 0) {
                return;
            }
            var m = this.itemData.list[index];
            this.itemData.list.splice(index, 1);
            //setTimeout(() => {
            this.itemData.list.splice(index - 1, 0, m);
            //}, 5000);
        },
        next(index) {
            if (index == this.itemData.list.length) {
                return;
            }
            var m = this.itemData.list[index];
            this.itemData.list.splice(index, 1);
            //setTimeout(() => {
            this.itemData.list.splice(index + 1, 0, m);
        },
    },
    mounted() {
        this.tt();
    },
    watch: {
        data() {
            this.tt();
        }
    }


};
</script>
<style>
.othercol {
    position: relative;
}

.new {
    /* background: #dffff0 */
}

.othercol .chox {
    position: absolute;
    bottom: 6px;
    right: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/wuliu/kehu/baojias/other.vue